export default __webpack_public_path__ + "static/media/yanahuara.6b6585a0.jpg";